import { bl_aat_engagement_category_RowClass } from '../../../dbschema/bl_aat_engagement_category.model';
import { BaseContainerModel } from '../../base-container.model';

export class EngagementCategoryContainerModel extends BaseContainerModel {
    bl_aat_engagement_category: bl_aat_engagement_category_RowClass = new bl_aat_engagement_category_RowClass();
}